// dashbaord
import Default from "../Components/Dashboard/Default";

// Admin module
import AdminModule from "../Components/Admin";

// Devices Management module
import DevicesManagementModule from "../Components/DevicesManagement";

// Account
import AccountPage from "../Components/Account";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: <Default /> },
  { path: `${process.env.PUBLIC_URL}/admin`, Component: <AdminModule /> },
  { path: `${process.env.PUBLIC_URL}/devices-management`, Component: <DevicesManagementModule /> },
  { path: `${process.env.PUBLIC_URL}/account`, Component: <AccountPage /> },
];
